import navStyle from "./nav.module.css"


export default function Nav(props) {

    const step = props['step']

    return(
        <div className={navStyle.navWrap}>
            <div className={`${navStyle.nav} ${step === 1 ? navStyle.active : ''}`}>
                <div>학원 선택</div>
            </div>

            <div className={navStyle.nextMark}>{'>'}</div>

            <div className={`${navStyle.nav} ${step === 2 ? navStyle.active : ''}`}>
                <div>행사 선택</div>
            </div>

            <div className={navStyle.nextMark}>{'>'}</div>

            <div className={`${navStyle.nav} ${step === 3 ? navStyle.active : ''}`}>
                <div>정보 입력</div>
            </div>

            <div className={navStyle.nextMark}>{'>'}</div>

            <div className={`${navStyle.nav} ${step === 4 ? navStyle.active : ''}`}>
                <div>결제</div>
            </div>

            <div className={navStyle.nextMark}>{'>'}</div>

            <div className={`${navStyle.nav} ${step === 'result' ? navStyle.active : ''}`}>
                <div>신청 완료</div>
            </div>
        </div>
    )
}